const activityArr = {
  zh: [
    {
      id: '主论坛', label: '主论坛',
      children: [
        { id: '5月9日未来医疗产业趋势峰会', label: '5月9日未来医疗产业趋势峰会' },
        { id: '5月10日未来医疗产业趋势峰会', label: '5月10日未来医疗产业趋势峰会' },
      ]
    },
    {
      id: '特色论坛', label: '特色论坛',
      children: [
        { id: '医疗器械设计与制造论坛', label: '医疗器械设计与制造论坛' },
        { id: '医疗器械经销商大会', label: '医疗器械经销商大会' },
        { id: '全球生物制造大会', label: '全球生物制造大会' },
        { id: '消费医疗与健康消费新渠道增长大会', label: '消费医疗与健康消费新渠道增长大会' },
      ]
    },
    {
      id: '主题论坛', label: '主题论坛',
      children: [
        { id: 'ITBT&AI药物研发论坛', label: 'ITBT&AI药物研发论坛' },
        { id: '眼科产业创新与发展论坛', label: '眼科产业创新与发展论坛' },
        { id: '智能医学影像发展论坛', label: '智能医学影像发展论坛' },
        { id: '精准医疗与分子诊断产业发展论坛', label: '精准医疗与分子诊断产业发展论坛' },
        { id: '心血管病产研创新论坛', label: '心血管病产研创新论坛' },
        { id: '健康管理与健康险发展论坛', label: '健康管理与健康险发展论坛' },
        { id: 'CGT创投及BD新机遇论坛', label: 'CGT创投及BD新机遇论坛' },
        { id: '透皮技术创新大会', label: '透皮技术创新大会' },
        { id: '制剂及原料药出海产品质量控制与检测标准大会', label: '制剂及原料药出海产品质量控制与检测标准大会' },
        { id: '内窥镜产业创新与发展论坛', label: '内窥镜产业创新与发展论坛' },
        { id: '手术机器人临床应用与产业创新论坛', label: '手术机器人临床应用与产业创新论坛' },
        { id: '多肽药物及产业链创新论坛', label: '多肽药物及产业链创新论坛' },
        { id: '肿瘤消融器械产业发展论坛', label: '肿瘤消融器械产业发展论坛' },
        { id: '微创外科产业创新与发展论坛', label: '微创外科产业创新与发展论坛' },
        { id: '神经介入创新发展论坛', label: '神经介入创新发展论坛' },
        { id: '口腔产业创新与发展论坛', label: '口腔产业创新与发展论坛' },
        { id: '急诊危重症创新与合作论坛', label: '急诊危重症创新与合作论坛' },
        { id: '骨科产业创新与发展论坛', label: '骨科产业创新与发展论坛' },
        { id: '再生医学创新发展论坛', label: '再生医学创新发展论坛' },
        { id: '医美产业创新与发展论坛', label: '医美产业创新与发展论坛' },
        { id: '脑科学与类脑科学前沿创新论坛', label: '脑科学与类脑科学前沿创新论坛' },
        { id: '外周血管介入产业创新论坛', label: '外周血管介入产业创新论坛' },
        { id: '智慧康养与积极老龄化发展论坛', label: '智慧康养与积极老龄化发展论坛' },
        { id: '医疗AI大模型应用创新论坛', label: '医疗AI大模型应用创新论坛' },
        { id: '互联网医院与智慧医院论坛', label: '互联网医院与智慧医院论坛' },
        { id: '科研成果转化发展论坛', label: '科研成果转化发展论坛' },
        { id: '感染性疾病防治创新与发展论坛', label: '感染性疾病防治创新与发展论坛' },
        { id: '中国器械全球化发展大会', label: '中国器械全球化发展大会' },
        { id: '中医药创新发展论坛', label: '中医药创新发展论坛' },
        { id: '药企数字化营销论坛', label: '药企数字化营销论坛' },
      ]
    },
    {
      id: '系列交流活动', label: '系列交流活动',
      children: [
        { id: '出海选品会', label: '出海选品会' },
        { id: '新品发布会', label: '新品发布会' },
        { id: '政企对接会', label: '政企对接会' },
        { id: '项目路演', label: '项目路演' },
        { id: '培训会', label: '培训会' },
        { id: '参访团', label: '参访团' },
      ]
    },
  ],
  en: [
    {
      id: '主论坛', label: 'The Main Forum',
      children: [
        { id: '5月9日未来医疗产业趋势峰会', label: 'The Future Medical Industry Trends Summit on 9th May' },
        { id: '5月10日未来医疗产业趋势峰会', label: 'The Future Medical Industry Trends Summit on 10th May' },
      ]
    },
    {
      id: '特色论坛', label: 'The Feature Forums',
      children: [
        { id: '医疗器械设计与制造论坛', label: `The Medical Device Design and Manufacturing Forum` },
        { id: '医疗器械经销商大会', label: `The Medical Device Distributors Conference` },
        { id: '全球生物制造大会', label: `The Global Biomanufacturing Conference` },
        { id: '消费医疗与健康消费新渠道增长大会', label: `The Growth of New Channels for Consumer Healthcare and Health Consumption Conference` },
      ]
    },
    {
      id: '主题论坛', label: 'The Theme Forum',
      children: [
        { id: 'ITBT&AI药物研发论坛', label: `The ITBT&AI for Drug Development Forum` },
        { id: '眼科产业创新与发展论坛', label: `The Ophthalmology Industry Innovation and Development Forum` },
        { id: '智能医学影像发展论坛', label: `The Intelligent Medical Imaging Development Forum` },
        { id: '精准医疗与分子诊断产业发展论坛', label: `The Precision Medicine and Molecular Diagnosis Industry Development Forum` },
        { id: '心血管病产研创新论坛', label: `The Cardiovascular Disease Research and Industry Innovation Forum` },
        { id: '健康管理与健康险发展论坛', label: `The Health Management and Health Insurance Development Forum` },
        { id: 'CGT创投及BD新机遇论坛', label: `The CGT Venture and BD New Opportunities Forum` },
        { id: '透皮技术创新大会', label: `The Transdermal Technology Innovation Conference` },
        { id: '制剂及原料药出海产品质量控制与检测标准大会', label: `The Quality Control and Testing Standards for Overseas Products of Preparations and Active Pharmaceutical Ingredients Conference` },
        { id: '内窥镜产业创新与发展论坛', label: `Endoscope Industry Innovation and Development Forum` },
        { id: '手术机器人临床应用与产业创新论坛', label: `Surgical Robot Clinical Application and Industry Innovation Forum` },
        { id: '多肽药物及产业链创新论坛', label: `Peptide Drug and Industry Chain Innovation Forum` },
        { id: '肿瘤消融器械产业发展论坛', label: `Tumor Ablation Device Industry Development Forum` },
        { id: '微创外科产业创新与发展论坛', label: `Minimally Invasive Surgery Industry Innovation and Development Forum` },
        { id: '神经介入创新发展论坛', label: `NeuroInterventional Innovation and Development Forum` },
        { id: '口腔产业创新与发展论坛', label: `Oral Industry Innovation and Development Forum` },
        { id: '急诊危重症创新与合作论坛', label: `Emergency Critical Care Innovation and Cooperation Forum` },
        { id: '骨科产业创新与发展论坛', label: `Orthopedic Industry Innovation and Development Forum` },
        { id: '再生医学创新发展论坛', label: `Regenerative Medicine Innovation and Development Forum` },
        { id: '医美产业创新与发展论坛', label: `Medical Cosmetology Industry Innovation and Development Forum` },
        { id: '脑科学与类脑科学前沿创新论坛', label: `Brain Science and Brain-Like Intelligence Frontier Innovation Forum` },
        { id: '外周血管介入产业创新论坛', label: `Peripheral Vascular Intervention Industry Innovation Forum` },
        { id: '智慧康养与积极老龄化发展论坛', label: `Intelligent Health and Wellness and Active Aging Development Forum` },
        { id: '医疗AI大模型应用创新论坛', label: `Medical AI Large Model Application Innovation Forum` },
        { id: '互联网医院与智慧医院论坛', label: `Internet Hospital and Smart Hospital Forum` },
        { id: '科研成果转化发展论坛', label: `Forum on the Transformation and Development of Scientific Research Achievements` },
        { id: '感染性疾病防治创新与发展论坛', label: `Forum on Innovation and Development of Infectious Diseases Prevention and Control` },
        { id: '中国器械全球化发展大会', label: `Global Development of Chinese Medical Devices Conference` },
        { id: '中医药创新发展论坛', label: `Traditional Chinese Medicine Innovative Development Forum` },
        { id: '药企数字化营销论坛', label: `Pharmaceutical Digital Marketing Forum` },
      ]
    },
    {
      id: '系列交流活动', label: 'Communication Activities',
      children: [
        { id: '出海选品会', label: `Overseas Product Selection Conference` },
        { id: '新品发布会', label: `New Product Launch Event` },
        { id: '政企对接会', label: `Government Enterprise Coordination Meeting` },
        { id: '项目路演', label: `Roadshow` },
        { id: '培训会', label: `Seminar` },
        { id: '参访团', label: `Visiting` },
      ]
    },
  ]
}



export default activityArr